import './style/bolmateTabs.scss';

import classNames from 'classnames';

import React from 'react';

import {BolmateTabsVariant} from '../../../util/types';

import {BolmateTab} from '../../../util/interfaces';

interface Props<T extends string | number = string> {
    tabs: Array<BolmateTab<T>>;
    activeTab: T;
    onChangeTab: (tab: T, event: React.MouseEvent) => void;
    variant?: BolmateTabsVariant;
    className?: string;
}

export default function BolmateTabs<T extends string | number = string>(props: Props<T>) {
    const {tabs, activeTab, onChangeTab, variant = 'underline', className} = props;

    function handleClick(tab: T) {
        return function (event: React.MouseEvent) {
            if (tab !== activeTab) onChangeTab(tab, event);
        };
    }

    return (
        <div className={classNames('bolmate-tabs', `variant-${variant}`, className)}>
            {tabs.map(tab => (
                <div
                    key={tab.key}
                    className={classNames('bolmate-tab', activeTab === tab.key && 'active')}
                    onClick={handleClick(tab.key)}
                >
                    <label className='bolmate-tab-label'>{tab.label}</label>
                </div>
            ))}
        </div>
    );
}
